import { useState } from 'react';
import { shorten } from '../../lib/format';
import { eurC } from '../../lib/money';
import { useApi } from '../../lib/useApi';
import { RechnungSchreiben } from './RechnungSchreiben';
import type { AbrechnungResponse } from './types';

// Leiste „Rechnung noch nicht geschrieben“ auf der Übersicht (nur Admin, Sam 11.10.): steht da, solange ein Mandant
// gebuchte Monate oder erledigte Unterlagen hat, die noch auf keiner Rechnung sind. Weg erst mit der Rechnung
// (oder „Nicht berechnen“ unter „Abrechnung“).
export function AbrechnungBar() {
  const res = useApi<AbrechnungResponse>('/api/kanzlei/abrechnung', { live: ['abrechnung', 'clients', 'invoices'] });
  const [all, setAll] = useState(false);
  const [write, setWrite] = useState<{ id: string; name: string } | null>(null);
  const open = res.data?.open ?? [];
  if (!open.length && !write) return null;
  const cut = open.length > 4 && !all;

  return (
    <>
      {open.length > 0 && (
        <div className="msgbar" role="status">
          <div className="mb-h">
            🧾{' '}
            {open.length === 1 ? 'Rechnung noch nicht geschrieben' : `${open.length} Mandanten: Rechnung noch nicht geschrieben`}
          </div>
          {(cut ? open.slice(0, 3) : open).map((g) => (
            <div className="mb-r" key={g.client.id}>
              <div className="tx">
                <b>{g.client.name}</b> · {eurC(g.net)} netto
                <small>{shorten(g.items.map((i) => i.description.replace(/, erstellt am .*$/, '')).join(' · '), 140)}</small>
              </div>
              <button type="button" className="btn sm dark" onClick={() => setWrite({ id: g.client.id, name: g.client.name })}>
                Rechnung schreiben
              </button>
            </div>
          ))}
          {open.length > 4 && (
            <button type="button" className="btn sm mb-more" aria-expanded={!cut} onClick={() => setAll((x) => !x)}>
              {cut ? `Alle anzeigen (${open.length})` : 'Weniger anzeigen'}
            </button>
          )}
        </div>
      )}
      {write && <RechnungSchreiben clientId={write.id} clientName={write.name} onClose={() => setWrite(null)} />}
    </>
  );
}
